import React from "react";
import bodyBG from "../assets/body-bg.png";

const Background = (props) => {
  return (
    <div className="bg-black relative overflow-hidden" style={{ backgroundImage: `url(${bodyBG})` }}>
      {props.children}
    </div>
  );
};

export default Background;
